import { cn } from "@/lib/utils";

interface ConfidenceBadgeProps {
  confidence: number;
  showLabel?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function ConfidenceBadge({
  confidence,
  showLabel = true,
  size = "md",
  className,
}: ConfidenceBadgeProps) {
  const getConfidenceLevel = (conf: number) => {
    if (conf >= 90)
      return {
        label: "High",
        color: "bg-success/20 text-success",
      };
    if (conf >= 70)
      return {
        label: "Medium",
        color: "bg-warning/20 text-warning",
      };
    if (conf >= 50) return { label: "Low", color: "bg-info/20 text-info" };
    return { label: "Very Low", color: "bg-muted text-muted-foreground" };
  };

  const { label, color } = getConfidenceLevel(confidence);

  const sizeClasses = {
    sm: "text-xs px-1.5 py-0.5",
    md: "text-sm px-2 py-1",
    lg: "text-base px-3 py-1.5",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md font-medium",
        color,
        sizeClasses[size],
        className
      )}
    >
      {showLabel ? (
        <>
          <span>{label}</span>
          <span className="opacity-70">({confidence}%)</span>
        </>
      ) : (
        <span>{confidence}%</span>
      )}
    </span>
  );
}
